import { render, staticRenderFns } from "./sys_role.vue?vue&type=template&id=309d4dc0&scoped=true"
import script from "./sys_role.vue?vue&type=script&lang=js"
export * from "./sys_role.vue?vue&type=script&lang=js"
import style0 from "./sys_role.vue?vue&type=style&index=0&id=309d4dc0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309d4dc0",
  null
  
)

export default component.exports